
import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../_services/index';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { environment } from 'environments/environment';
import {
  GridDataResult,
} from '@progress/kendo-angular-grid';
import { anyChanged } from '@progress/kendo-angular-grid/dist/es2015/utils';
import * as JSONEditor from 'jsoneditor';
declare var $: any;

import { UccUsersService } from './uccUsers.service';
import { uccUsers } from './uccUsers.model';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';



@Component({
  selector: 'uccUsers-Ucc',
  templateUrl: 'uccUsers.Component.html',
})
export class UccUsersComponent {
  filterData: any
  setWardSuccess: any
  setDenoSuccess: any
  setPermsSuccess: any
  Employeedata: any
  search: any
  prjId: any;
  userId: any;
  showLoader: any;
  collectionList: any;
  dataRangeModal: any;
  startDate: any;
  endDate: any;
  defaultStartDate: any;
  defaultEndDate: any;
  uccMobileUserList: any;
  dateLink: any;
  geocoder: any;
  uccRecardStatus = false;
  address: any;
  // public editor: any
  // public container: any
  // public options: any
  public userPermList: any;
  public userMobileNo: any;
  jsonObject: any;
  parshJson: any;
  zoneList: any
  wardList: any
  public gridDataCouponCollection: GridDataResult
  userFBID: any;
  userName: any;
  deviceId: any;
  vehMaintDoc: AngularFirestoreDocument<uccUsers>;
  jsonData: uccUsers;
  wardName: string;
  wardID: string;
  strfData: any;
  prjs;
  prjName: any;
  userData: any;
  prjActiveStatus: any;
  zoneSelect: string;
  zoneName: string;
  wardSelect: string;
  kccZoneActiveStatus: boolean;
  denominations = [];
  uccZones = [];
  uccBlankZones = [];
  amt: any;
  amtActive: any;
  addAmount: any;
  addActive: any;
  kccZones = [];
  kccZoneSelect: any;
  newKccZone: { ZONEID: any; ZONENAME: any; };
  newUccZone: { ZONEID: string; ZONENAME: any; wards: any[]; };
  wards: any[];
  newPrjID: any;
  selectedUccZones: any[];
  uccWards = [];
  loading: boolean = true;
  kccPrjName: string;
  kccZoneList: any;

  constructor(private http: HttpClient, private auth: AuthService, public afs: AngularFirestore, private loaderService: LoaderService, private _ucc: UccUsersService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
      this.prjs = [
        { id: 1, name: 'LUCKNOW' },
        { id: 2, name: 'GURUGRAM' },
        { id: 3, name: 'FARIDABAD' },
        { id: 4, name: 'GWLIOR' },
      ];
    });

    this.filterData = {}
    var firstDay = new Date();
    var lastDay = new Date();
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defaultEndDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.dataRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() } };
    $("#save-loader").hide()
  }

  importUccMobileReport(data) {
    const ws_name = 'importUccMobileReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'uccMobileReport.xlsx');
  } s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }

  /*
   * GET UCC RECEIPT REPORT 
   */
  getUccUserReport() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'uccnew/uccUsersReport?prjid=' + this.prjId).subscribe(data => {
      this.uccMobileUserList = data;
      if (this.uccMobileUserList.length > 0) {
        this.loaderService.display(false);
        this.uccRecardStatus = false;
      } else {
        this.uccRecardStatus = true;
        this.loaderService.display(false);
      }
    });
  }

  clearFields() {
    this.setPermsSuccess = false
    this.userMobileNo = null
    this.userFBID = null
    this.userName = null
    this.deviceId = null
    this.prjName = null
    this.prjActiveStatus = null
    this.zoneSelect = null
    this.uccZones = null
    this.denominations = null
  }

  refresh() {
    this.http.get(environment.apiUrl + 'uccnew/uccUsersReport').subscribe(data => { });
  }
  ngOnInit() {
    this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    // this.container = document.getElementById("jsoneditor");
    // this.options = {};
    // this.editor = new JSONEditor(this.container, this.options);
    this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.getUccUserReport();
    this.geocoder = new google.maps.Geocoder;
    // this.getZone()
  }
}









// WEBPACK FOOTER //
// ./src/app/reports/uccReport/uccUsers.Component.ts